import React from 'react';

type Props = {
  width?: number;
  height?: number;
  color?: string;
};

const IconUserMinus: React.FC<Props> = ({
  width = 20,
  height = 20,
  color = '#3E454D',
}: Props) => (
  <svg width={width} height={height} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.17436 8.95833C11.1277 8.95833 12.716 7.36917 12.716 5.41667C12.716 3.46417 11.1277 1.875 9.17436 1.875C7.22102 1.875 5.63269 3.46417 5.63269 5.41667C5.63269 7.36917 7.22102 8.95833 9.17436 8.95833ZM9.17436 3.125C10.4385 3.125 11.466 4.1525 11.466 5.41667C11.466 6.68083 10.4385 7.70833 9.17436 7.70833C7.91019 7.70833 6.88269 6.68083 6.88269 5.41667C6.88269 4.1525 7.91019 3.125 9.17436 3.125ZM3.9585 15.0167C3.9585 16.3192 4.51933 16.875 5.8335 16.875H11.6668C12.0118 16.875 12.2918 17.155 12.2918 17.5C12.2918 17.845 12.0118 18.125 11.6668 18.125H5.8335C3.8185 18.125 2.7085 17.0208 2.7085 15.0167C2.7085 12.7983 3.9635 10.2083 7.50016 10.2083H10.8335C13.8068 10.2083 14.9118 12.0325 15.3043 13.1208C15.4218 13.445 15.2535 13.8033 14.9294 13.9208C14.6069 14.04 14.2476 13.8708 14.1293 13.5458C13.6276 12.1608 12.5193 11.4583 10.8335 11.4583H7.50016C4.21433 11.4583 3.9585 14.1825 3.9585 15.0167ZM18.1252 15.8333C18.1252 16.1783 17.8452 16.4583 17.5002 16.4583H14.1668C13.8218 16.4583 13.5418 16.1783 13.5418 15.8333C13.5418 15.4883 13.8218 15.2083 14.1668 15.2083H17.5002C17.8452 15.2083 18.1252 15.4883 18.1252 15.8333Z" fill={color} />
  </svg>

);

export default IconUserMinus;
